const DEFAULT_API_URL = 'https://api.qualityassurance.work';

/** Base API URL without trailing slash (CRA: REACT_APP_API_URL). */
export function getApiUrl() {
    let base = process.env.REACT_APP_API_URL || DEFAULT_API_URL;
    base = base.replace(/\/$/, '');
    // Mixed-content guard: never call http:// APIs from an https:// page.
    if (
        typeof window !== 'undefined' &&
        window.location.protocol === 'https:' &&
        base.startsWith('http://')
    ) {
        base = `https://${base.slice('http://'.length)}`;
    }
    return base;
}

export function apiPath(path) {
    const suffix = path.startsWith('/') ? path : `/${path}`;
    return `${getApiUrl()}${suffix}`;
}

export async function parseJsonResponse(response) {
    try {
        return await response.json();
    } catch {
        return {};
    }
}
